module.exports = __webpack_public_path__ + "img/nofeedback.6ba7ed74.svg";